import { useSelector } from "react-redux";
import Rule from "../../../Rule/Index";
import CloseButton from "../../../CloseButton";
import Backdrop from "../../../Backdrop";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { CiCirclePlus } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import toast from "react-hot-toast";
import { errorBlock } from "../../../../controllers/errorBlock";
import axios from "../../../../utils/axios";
import {
  notification,
  Select,
  Input,
  Button,
  Modal,
  Form,
  Space,
  Card,
  Divider,
  Typography,
  Collapse,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { channelController } from "../../../../controllers/channelController";
import { precache } from "workbox-precaching";

const { Title, Text } = Typography;

const AddUnlimitedPlan = ({ open, setopen, refreshbtn, customerclass }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setloading] = useState(false);
  const [classtype, setclasstype] = useState("");
  const { siteid, sitename } = useSelector((state) => state.projectSite);
  const { username } = useSelector((state) => state.userDetails);
  const [form] = Form.useForm();

  const addEntry = (e) => {
    e.preventDefault();
    const newEntry = {
      price_per_kWh: 0,
      min_units: entries.length > 0 ? entries[entries.length - 1].max_units : 0,
      max_units: "null",
    };
    setEntries([...entries, newEntry]);
  };

  const removeEntry = (index) => {
    const updatedEntries = entries.filter((_, i) => i !== index);
    if (index > 0 && index < entries.length) {
      updatedEntries[index].min_units = entries[index - 1].max_units;
    }
    setEntries(updatedEntries);
  };

  const updateEntry = (index, field, value) => {
    const updatedEntries = [...entries];
    updatedEntries[index][field] = value;
    if (field === "max_units" && index < entries.length - 1) {
      updatedEntries[index + 1].min_units = value;
    }
    setEntries(updatedEntries);
  };

  const onSubmit = async (values) => {
    try {
      if (entries.length === 0) {
        return toast.error("Select at least one tier");
      }
      if (!classtype) {
        return toast.error("Please select a customer class");
      }
      setloading(true);

      let formattedres = entries.map((i) => {
        return {
          price_per_kWh: Number(i.price_per_kWh),
          min_units: Number(i.min_units),
          max_units: i.max_units === "null" ? null : Number(i.max_units),
        };
      });

      let res = await axios.post("/vending/tieredpricing/settieredprice", {
        siteid: Number(siteid),
        customerclass: classtype,
        pricingtierjson: JSON.stringify({ tiers: formattedres }),
        setby: username,
      });

      const result = channelController(res);

      if (result.type !== "success") {
        notification.error({
          message: "Failed",
          description: res.data?.message || "Failed to create plan",
        });
        setloading(false);
        return;
      }

      notification.success({
        message: "Success",
        description: result?.message?.message,
      });

      setloading(false);
      setopen(false);
      refreshbtn((prev) => !prev);
      form.resetFields();
      setEntries([]);
      setclasstype("");
    } catch (error) {
      setloading(false);
      errorBlock(error);
    }
  };

  return (
    <Modal
      title={
        <div>
          <Title level={4} className="mb-2">
            Create Unlimited Energy Plan for customers in{" "}
            <span className="text-blue-600">{sitename}</span>
          </Title>
          <Text type="secondary">
            Fill in the fields to create customer class for customers
          </Text>
        </div>
      }
      open={open}
      onCancel={() => {
        setopen(false);
        form.resetFields();
        setEntries([]);
        setclasstype("");
      }}
      width={600}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit} className="mt-4">
        <Form.Item
          label="Customer Class"
          name="customerClass"
          rules={[
            { required: true, message: "Please select a customer class" },
          ]}
        >
          <Select
            placeholder="Select customer class"
            size="large"
            showSearch
            onChange={(value) => setclasstype(value)}
            options={customerclass.map((i) => ({
              value: i.customerClass,
              label: `${i.customerClass} - ${i.customerType}`,
            }))}
          />
        </Form.Item>

        <Form.Item label="Pricing Tiers">
          <Card className="bg-gray-50">
            {entries.map((entry, index) => (
              <div key={index} className="mb-3 last:mb-0">
                <Space.Compact className="w-full">
                  <Input
                    placeholder="Min units"
                    value={entry.min_units}
                    onChange={(e) =>
                      updateEntry(index, "min_units", e.target.value)
                    }
                    readOnly={index > 0}
                    className="flex-1"
                  />
                  <Input
                    placeholder="Max units"
                    value={
                      entry.max_units === "null" ? "infinity" : entry.max_units
                    }
                    onChange={(e) =>
                      updateEntry(index, "max_units", e.target.value)
                    }
                    className="flex-1"
                  />
                  <Input
                    placeholder="Price per kWh"
                    value={entry.price_per_kWh}
                    onChange={(e) =>
                      updateEntry(index, "price_per_kWh", e.target.value)
                    }
                    className="flex-1"
                  />
                  <Button
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={() => removeEntry(index)}
                    className="text-red-500 hover:text-red-700"
                  />
                </Space.Compact>
              </div>
            ))}

            <Button
              // type="dashed"
              icon={<PlusOutlined />}
              onClick={addEntry}
              className="w-full mt-3 border-green-500 text-green-600 hover:border-green-600 hover:text-green-700"
            >
              Add Tier
            </Button>
          </Card>
        </Form.Item>

        <Collapse
          size="small"
          className="mb-4"
          items={[
            {
              key: "1",
              label: (
                <div className="flex items-center">
                  <InfoCircleOutlined className="mr-2 text-blue-500" />
                  <span className="font-medium">
                    Tiered pricing information
                  </span>
                </div>
              ),
              children: (
                <div className="text-gray-600">
                  <p className="mb-2 font-medium">
                    Tiered pricing for unlimited energy:
                  </p>
                  <p className="text-sm">
                    The TOU refers to the time the settings of the customer
                    class would be active on the customer's meter
                  </p>
                </div>
              ),
            },
          ]}
        />

        <Form.Item className="!mt-4">
          <Space className="w-full justify-end">
            <Button
              onClick={() => {
                setopen(false);
                form.resetFields();
                setEntries([]);
                setclasstype("");
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="bg-black hover:bg-gray-800"
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddUnlimitedPlan;
